import { Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { IS_STORE_BUILD } from "@/config/storeBuild";
import LoginPage from "@/pages/LoginPage";
import CompanySignupPage from "@/pages/CompanySignupPage";
import PaymentResultPage from "@/pages/PaymentResultPage";
import JoinPage from "@/pages/JoinPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import LegalPage from "@/pages/LegalPage";
import SupportPage from "@/pages/SupportPage";
import PricingPage from "@/pages/PricingPage";
import SetPasswordPage from "@/pages/SetPasswordPage";
import AppReadyPage from "@/pages/AppReadyPage";
import ReceiptPage from "@/pages/ReceiptPage";
import PendingApprovalPage from "@/pages/PendingApprovalPage";
import CompleteProfilePage from "@/pages/CompleteProfilePage";
import PlatformLoginPage from "@/pages/PlatformLoginPage";
import PlatformPage from "@/pages/PlatformPage";
import PublicBillSignPage from "@/pages/PublicBillSignPage";
import VerifySealPage from "@/pages/VerifySealPage";
import PayConfirmPage from "@/pages/PayConfirmPage";
import { GuestRoute } from "@/routes/GuestRoute";
import { PlatformRoute } from "@/routes/ProtectedRoute";

// Routes reachable without an employee session (plus the platform owner area).
export const publicRoutes = [
  <Route
    key="login"
    path="/login"
    element={
      <GuestRoute>
        <LoginPage />
      </GuestRoute>
    }
  />,
  <Route key="signup" path="/signup" element={<CompanySignupPage />} />,
  <Route key="forgot" path="/forgot-password" element={<ForgotPasswordPage />} />,
  <Route key="terms" path="/terms" element={<LegalPage kind="terms" />} />,
  <Route key="pricing" path="/pricing" element={IS_STORE_BUILD ? <Navigate to="/login" replace /> : <PricingPage />} />,
  <Route key="privacy" path="/privacy" element={<LegalPage kind="privacy" />} />,
  <Route key="eula" path="/eula" element={<LegalPage kind="eula" />} />,
  <Route key="biometric" path="/biometric-consent" element={<LegalPage kind="biometric" />} />,
  <Route key="deletion" path="/delete-account" element={<LegalPage kind="deletion" />} />,
  <Route key="support" path="/support" element={<SupportPage />} />,
  <Route key="verify-seal" path="/verify/:hash" element={<VerifySealPage />} />,
  <Route key="sign-bill" path="/sign/bill/:token" element={<PublicBillSignPage />} />,
  <Route key="sign-short" path="/s/:slug" element={<PublicBillSignPage />} />,
  <Route key="pc" path="/pc/:token" element={<PayConfirmPage />} />,
  <Route key="reset" path="/reset-password" element={<SetPasswordPage mode="reset" />} />,
  <Route key="invite-accept" path="/accept-invite" element={<SetPasswordPage mode="invite" />} />,
  <Route key="app-ready" path="/app-ready" element={<AppReadyPage />} />,
  <Route key="receipt" path="/receipt/:token" element={<ReceiptPage />} />,
  <Route key="pay-ok" path="/payment/success" element={IS_STORE_BUILD ? <Navigate to="/" replace /> : <PaymentResultPage outcome="success" />} />,
  <Route key="pay-no" path="/payment/cancel" element={IS_STORE_BUILD ? <Navigate to="/" replace /> : <PaymentResultPage outcome="cancel" />} />,
  <Route key="join" path="/join" element={<JoinPage />} />,
  <Route key="join-token" path="/join/:token" element={<JoinPage />} />,
  <Route key="pending" path="/pending" element={<PendingApprovalPage />} />,
  <Route key="complete-profile" path="/complete-profile" element={<CompleteProfilePage />} />,
  <Route
    key="platform-login"
    path="/platform/login"
    element={
      <GuestRoute to="/platform">
        <PlatformLoginPage />
      </GuestRoute>
    }
  />,
  <Route
    key="platform"
    path="/platform"
    element={
      <PlatformRoute>
        <PlatformPage />
      </PlatformRoute>
    }
  />,
];
